import DataObjectMap from 'assets/components/dataObjectMap/DataObjectMap';
import { useModalForm } from 'assets/components/form/modalForm/ModalForm';
import FormatValue from 'assets/components/formatValue/FormatValue';
import Icon from 'assets/components/icon/Icon';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import NumberInput from 'assets/components/inputs/number/NumberInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import { defaultInputDateFormat } from 'assets/utils/data/Date';
import { useEffect, useState } from 'react';
import { useSalesContractProvider } from '../../Sales.Contract.Hooks';
import { CancellationForm } from '../Sales.Contract.Cancellation';

const ContractCancellationRefund: React.FC = () => {
  const { lang } = getLocales();
  const { form } = useModalForm<CancellationForm>();
  const { isDealer } = useAuthStore();
  const { selected } = useSalesContractProvider();

  const [initialPricingDistributions] = useState(() => JSON.parse(JSON.stringify(selected.pricingDistributions)));

  const [initialDistributorDistributions] = useState(() =>
    JSON.parse(JSON.stringify(selected.distributorDistributions))
  );

  function updateContractCancelationRequest(
    contractCancelationRequest: Api.Core.Contract.SetStatus.ContractCancellationRequest
  ) {
    form.merge({ contractCancelationRequest });
  }

  useEffect(() => {
    form.merge({
      contractCancelationRequest: {
        refundPricingDistributions: selected?.pricingDistributions || {},
        refundDistributorDistributions: selected?.distributorDistributions || {},
      },
    });
  }, []);

  return (
    <>
      <FormWrapper>
        <DateInput
          name="refundDateAtLocal"
          label={lang.refundDate}
          dateTimeFormat={defaultInputDateFormat}
          isLocal={true}
          value={form?.data?.contractCancelationRequest?.refundDateAtLocal}
          error={form?.errors?.contractCancelationRequest?.refundDateAtLocal}
          onChange={updateContractCancelationRequest}
          icon={<Icon class="fas-calendar-alt" />}
        />
      </FormWrapper>
      <table className={ThemeTableSimple}>
        <thead>
          <tr>
            <th>{lang.pricingDistributions}</th>
            <th>{lang.originalPrice}</th>
            <th>{lang.adjustedPrice}</th>
          </tr>
        </thead>
        <tbody>
          <DataObjectMap
            data={form.data.contractCancelationRequest.refundPricingDistributions}
            render={({ data: pricingInfo, key }) => {
              const old = initialPricingDistributions[key];
              return (
                <tr key={key}>
                  <td>{key}</td>
                  <td>
                    <FormatValue value={`${(old?.amount ?? 0).toFixed(2)}$`} />
                  </td>
                  <td>
                    <NumberInput
                      name="amount"
                      value={pricingInfo.amount}
                      onChange={({ amount }) =>
                        form.merge({
                          contractCancelationRequest: {
                            refundPricingDistributions: {
                              [key]: {
                                amount,
                              },
                            },
                          },
                        })
                      }
                      style={{
                        formInput: {
                          minWidth: '157px',
                        },
                        input: {
                          textAlign: 'right',
                        },
                      }}
                      icon={<Icon class={'fas-dollar-sign'} />}
                      min={0}
                      step={0.01}
                      roundOnBlur
                    />
                  </td>
                </tr>
              );
            }}
          />
        </tbody>
        {!isDealer && (
          <>
            <thead>
              <tr>
                <th>{lang.distributorDistributions}</th>
                <th>{lang.originalPrice}</th>
                <th>{lang.adjustedPrice}</th>
              </tr>
            </thead>
            <tbody>
              <DataObjectMap
                data={form.data.contractCancelationRequest.refundDistributorDistributions}
                render={({ data: pricingInfo, key }) => {
                  const old = initialDistributorDistributions[key];
                  return (
                    <tr key={key}>
                      <td>{key}</td>
                      <td>
                        <FormatValue value={`${(old?.amount ?? 0).toFixed(2)}$`} />
                      </td>
                      <td>
                        <NumberInput
                          name="amount"
                          value={pricingInfo.amount}
                          onChange={({ amount }) =>
                            form.merge({
                              contractCancelationRequest: {
                                refundDistributorDistributions: {
                                  [key]: {
                                    amount,
                                  },
                                },
                              },
                            })
                          }
                          style={{
                            formInput: {
                              minWidth: '157px',
                            },
                            input: {
                              textAlign: 'right',
                            },
                          }}
                          icon={<Icon class={'fas-dollar-sign'} />}
                          min={0}
                          step={0.01}
                          roundOnBlur
                        />
                      </td>
                    </tr>
                  );
                }}
              />
            </tbody>
          </>
        )}
      </table>
    </>
  );
};

export default ContractCancellationRefund;
